<sc-auth-page-wrapper [mainTitle]="mainTitle">
  <ng-content auth-page-wrapper-subtitle></ng-content>
  <div class="content" auth-page-wrapper-content *ngIf="imageSource">
    <img [src]="imageSource" alt="Imagen">
  </div>
  <ng-content select="[footer]" auth-page-wrapper-footer></ng-content>
  <ng-content select="[background-content]" auth-page-wrapper-background-content></ng-content>
</sc-auth-page-wrapper>
